<template>
    <div class="modal-body p-sm-5 p-3 text-center">
        <div v-if="status === 'error'" class="text-danger">
            Aktywacja promocji nie powiodła się.
            Napisz na <a href="mailto:bok@europlatform.pl">bok@europlatform.pl</a>
            lub zadzwoń na numer <a href="tel:48221291400">+48 22 12 91 400</a>
        </div>

        <page-preloader
            v-else-if="status === 'waiting'"
            min-height="100px"
        />

        <template v-else>
            <h4 v-if="!loaderVisible" class="mt-1">
                {{
                    total & total === processed
                        ? 'Promocje zostały przetworzone.'
                        : 'Trwa przetwarzanie promocji.'
                }}
            </h4>

            <page-preloader v-if="loaderVisible" min-height="100px" />
            <progress-bar v-else class="mx-5 my-4" :bar-width="barWidth || 0" />

            <h3 class="h5 mb-0">
                Przetworzono {{ processedPercentage }}%
            </h3>

            <the-hints
                v-if="status === 'processing'"
                class="mt-5 mt-sm-5 mb-3 md-sm-0"
                snippet-code="snippet004"
            />
        </template>
    </div>
</template>

<script>
export default {
    data: () => ({
        loaderVisible: false
    }),
    computed: {
        progress() {
            return this.$store.getters.getSubscriptionsProgress || {}
        },
        total() {
            return this.progress.total
        },
        processed() {
            return this.progress.processed
        },
        status() {
            return this.progress.status
        },
        processedPercentage() {
            const processed = this.processed || 0
            const total = this.total || 1

            return Math.round((processed / total) * 100)
        },
        barWidth() {
            return (100 / this.total) * this.processed
        }
    },
    methods: {
        goToSummary() {
            this.$emit('changeStep')
        }
    },
    watch: {
        status() {
            if (this.status === 'finished') {
                setTimeout(() => {
                    this.goToSummary()
                }, 1000)
            }
        },

        processed() {
            if (this.processed === this.total) {
                setTimeout(() => {
                    this.loaderVisible = true
                }, 2000)
            }
        }
    }
}
</script>
